// src/logger.ts
function makeLogger(method: 'debug' | 'info' | 'warn' | 'error', style: string) {
    // %c%s applies CSS to the entire message string
    return console[method].bind(console, '%c%s', style)
}
export const log = {
    debug: makeLogger('debug', 'color: black; font-weight: normal'),
    info: makeLogger('info', 'color: blue; font-weight: bold'),
    warn: makeLogger('warn', 'color: black; font-weight: normal'),
    error: makeLogger('error', 'color: black; font-weight: normal'),
    success: makeLogger('info', 'color: green; font-weight: bold')
}

// Cola global de tareas de logging
// let loggingQueue = Promise.resolve()

// function makeAsyncLogger(method: 'debug' | 'info' | 'warn' | 'error', style: string) {
//     return (...args: any[]) => {
//         // Encadena la operación en la cola
//         loggingQueue = loggingQueue.then(() => {
//             console[method]('%c%s', style, args.join(' '))
//         })
//     }
// }

// export const log = {
//     debug: makeAsyncLogger('debug', 'color: black; font-weight: normal'),
//     info: makeAsyncLogger('info', 'color: blue; font-weight: bold'),
//     warn: makeAsyncLogger('warn', 'color: black; font-weight: normal'),
//     error: makeAsyncLogger('error', 'color: black; font-weight: normal'),
//     success: makeAsyncLogger('info', 'color: green; font-weight: bold'),

//     // Vitest puede esperar esto
//     flush() {
//         return loggingQueue
//     }
// }
